<template>
  <div class="article-section" :id="domId">
    <div class="article-section__title">{{ section.title }}</div>
    <!-- rebuild -->
    <div class="rotator-wrapper" v-if="!section.disable_swiper">
      <v-btn
        class="rotator-wrapper__control"
        :style="{ visibility: visibleControls ? 'visible' : 'hidden' }"
        icon
        @click="swiperInstance.slidePrev()"
      >
        <v-icon size="40">$chevron_left</v-icon>
      </v-btn>
      <swiper ref="instance" class="rotator" :options="swiperOption">
        <swiper-slide v-for="(article, index) in articles" :key="article.id">
          <Article
            :nextId="getId(index + 1)"
            :prevId="getId(index - 1)"
            :article="article"
          />
        </swiper-slide>
      </swiper>
      <v-btn
        class="rotator-wrapper__control"
        :style="{ visibility: visibleControls ? 'visible' : 'hidden' }"
        icon
        @click="swiperInstance.slideNext()"
      >
        <v-icon size="40">$chevron_right</v-icon>
      </v-btn>
    </div>
    <div class="no-swiper" v-else>
      <div
        class="no-swiper-slide"
        v-for="(article, index) in articles"
        :key="article.id"
      >
        <Article
          :nextId="getId(index + 1)"
          :prevId="getId(index - 1)"
          :article="article"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Article from "./ArticleSection/Article";

export default {
  name: "ArticleSection",
  components: { Article },
  props: {
    section: Object,
  },
  mounted() {
    this.swiperInstance = this.$refs.instance.swiperInstance;

    if (location.hash.substring(1) == this.domId) {
      const y = this.$el.getBoundingClientRect().top + window.scrollY;
      window.scroll({
        top: y - 70,
        behavior: "smooth",
      });
    }

    let slideTo = -1;

    const { article_id } = this.$route.query;
    if (article_id) {
      slideTo = this.articles.findIndex((t) => t.id == article_id);
    }

    if (slideTo == -1) {
      const lastPublished = this.articles
        .map((t) => t.published)
        .lastIndexOf(true);
      if (lastPublished == -1) {
        if (this.articles[0]?.published) {
          slideTo = this.articles.length - 1;
        } else {
          slideTo = 0;
        }
      } else {
        slideTo = lastPublished;
      }
    }

    this.swiperInstance.slideTo(slideTo);
  },
  methods: {
    getId(index) {
      const article = this.section.articles[index];
      return article?.posted ? article.id : null;
    },
  },
  computed: {
    articles() {
      return this.section.articles;
    },
    domId() {
      return this.section.title
        .toLowerCase()
        .split(" ")
        .join("-");
    },
    visibleControls() {
      const conditions = [
        this.$size == "sm" && this.section.articles.length > 2,
        this.$size == "md" && this.section.articles.length > 3,
        (this.$size == "lg" || this.$size == "xl") &&
          this.section.articles.length > 4,
      ];

      return conditions.find((t) => t);
    },
    swiperOption() {
      return {
        speed: 400,
        breakpoints: {
          0: {
            slidesPerView: 1.12,
            spaceBetween: 20,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          960: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1264: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      };
    },
  },
};
</script>

<style scoped lang="scss">
.article-section {
  margin-bottom: 50px;

  &__title {
    font-family: "Roboto Condensed";
    text-transform: uppercase;
    font-weight: 300;
    font-size: 36px;
    line-height: 1.1em;
    color: #676767;
    border-bottom: 2px solid $primary;
    padding-bottom: 8px;
    margin: 35px 56px 50px 56px;
  }
}

.rotator-wrapper {
  position: relative;

  &__control {
    position: relative;
    top: -30px;
  }
}

.no-swiper {
  display: flex;
  flex-wrap: wrap;
  margin: 35px 56px 50px 120px;
}

.no-swiper-slide {
  flex-basis: 23.75%;
  margin-bottom: 2em;
  margin-right: 1.66%;
  &:nth-child(4n) {
    margin-right: 0;
  }
}

@media screen and (max-width: 1264px) {
  .article-section__title {
    margin: 40px;
  }

  .rotator-wrapper {
    padding-left: 20px;
  }

  .no-swiper {
    margin: 40px;
  }

  .no-swiper-slide {
    flex-basis: 31.84%;
    margin-right: 2.24%;
    &:nth-child(4n) {
      margin-right: 2.24%;
    }
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 960px) {
  .no-swiper-slide {
    flex-basis: 48.3%;
    margin-right: 1.4%;
    &:nth-child(4n),
    &:nth-child(3n) {
      margin-right: 1.4%;
    }
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}

@media screen and (max-width: 600px) {
  .article-section__title {
    margin: 40px 15px;
    font-size: 1.7em;
  }

  .swiper-container {
    overflow: visible;
  }

  .rotator-wrapper {
    margin-right: 20px;
    padding-right: 20px;
    padding-left: 0;
  }

  .no-swiper {
    margin: 20px;
  }

  .no-swiper-slide {
    flex-basis: 100%;
    margin-right: 0;
    &:nth-child(4n),
    &:nth-child(3n),
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>
